export default __webpack_public_path__ + "static/media/Product_Sheet.161f57cb.xlsx";